export const fetchAlternativeProductsLinkInfo = (body, token, apiUrl) => {
    if (!!!token && !!!apiUrl || !!!body)
        return Promise.resolve();
    return fetch(`${apiUrl}`, {
        method: "POST",
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(body)
    })
        .then(response => response.json())
        .then((res) => {
        return Promise.resolve(res.products);
    }).catch((error) => {
        console.error(error);
        return Promise.resolve();
    });
};
